module.exports = __webpack_public_path__ + "img/Confirms.b8c514eb.png";